import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';

const VideoPlayer = ({ videoUrl }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
    }
  }, [videoUrl]);

  return (
    <div style={{ textAlign: 'center' }}>
     <video
        ref={videoRef}
        controls
        playsInline
        muted
        preload="metadata"
        style={{ width: '100%', maxWidth: '720px', height: 'auto' }}
      >
        <source src={videoUrl} type="video/webm" />
        Your browser does not support the video tag.
      </video> 

    </div>

    
  );
};

// Correct the prop type declaration
VideoPlayer.propTypes = {
  videoUrl: PropTypes.string.isRequired, // Marked as required for better validation
};

export default VideoPlayer;
